import { render, staticRenderFns } from "./baseSelectMembers.vue?vue&type=template&id=4af13a22&scoped=true&"
import script from "./baseSelectMembers.vue?vue&type=script&lang=ts&"
export * from "./baseSelectMembers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af13a22",
  null
  
)

export default component.exports